const DesafioSemanal6 = () => {
  return (
    <div className="bg-white">
      <h4 className="mb-4" style={{ color: "#99CBC8" }}>
        <span
          style={{
            borderBottom: "3px solid #99CBC8",
            display: "inline-block",
            paddingBottom: "2px",
          }}
        >
          Desafio Semanal
        </span>
      </h4>

      <div className="mb-4 lead">
        <p className="mb-3 fw-bold">
          Queria lançar-te um último desafio!
        </p>
        <p>
          Sempre que identificares uma <strong>situação do teu dia a dia</strong> em que sentes que poderia ser útil 
          <strong> procurar ajuda.</strong>
        </p>
        <p>
          <strong>Não precisa ser algo muito desconfortável</strong>, pode ser, por exemplo, uma preocupação com um teste importante
          , um jogo que vais ter ou até um desentendimento com um amigo.
        </p>
        <p>
          O objetivo é <strong>identificar essas situações e procurares ajuda</strong> seja com um amigo, um familiar ou até um psicólogo.
        </p>
        <p>
          Este desafio tem como objetivo ajudar-te a <strong>dar o primeiro passo em direção a seres mais consciente da importância de procurar ajuda</strong>, mesmo para as pequenas dificuldades do dia a dia, como conversar sobre uma preocupação ou pedir conselhos.
        </p>

        <p><strong className="fw-bold">Vamos em frente! #UmNovoComeço</strong></p>
      </div>
    </div>
  );
};

export default DesafioSemanal6 ;

